module.exports = __webpack_public_path__ + "static/media/ASAP_Program.5abec53a.png";